/**
 * Ugandan shilling.
 */
export var UGX = {
  code: 'UGX',
  base: 10,
  exponent: 0
};